export default __webpack_public_path__ + "static/media/arrow-dropdown.fc93d66b.svg";